import React from 'react';
import auditbuddyLogo from '../../../assets/auditbuddy-logo.svg';

export default function CooTopBar() {
  return (
    <header className="sticky top-0 z-50 border-b border-app-border/80 bg-white/[0.85] backdrop-blur-lg supports-[backdrop-filter]:bg-white/[0.75]">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4">
          <img src={auditbuddyLogo} alt="AuditBuddy" className="h-8 w-auto sm:h-9" />
          <div className="hidden h-5 w-px bg-app-border sm:block" />
          <div className="hidden sm:block">
            <div className="text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-400">Executive Demo</div>
            <div className="text-[13px] font-medium text-slate-700">Aerial Telecom COO Intelligence</div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <span className="rounded-full border border-app-border bg-slate-50 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-500">
            /coo-dashboard
          </span>
        </div>
      </div>
    </header>
  );
}
